import smartSolveApi from './instances/smartsolve';

export const getDictionary = async (data) => {
  return await smartSolveApi.post('/getregulatoryterms', data);
};

export async function getMEDDRAChildren(data) {
  return await smartSolveApi.post('/getregulatorytermschildren', data);
}

export const getPrediction = async (text) => {
  return await smartSolveApi.post('/predictiondata', {
    StringToTranslate: text,
  });
};
